import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {
  ACTUALIZARCOMISIONEMPLE, ACTUALIZARCOMISIONEMPLEV2,
  ADDCOMISION, ADDUPDATEEMPLECOMISION, APROBARCOMISIONEMPLE, APROBARMANUALCOMISION, ELIMINARCOMISION, ELIMINARCOMISIONEMPLE,
  GETALLCOMISIONES,
  GETCOMISION, GETEMPLEADOSCOMISION,
  GETINFOEMPLEADO,
  GETINFOEMPLEADOCALENDARIO, GETINFOEMPLEADOCALENDARIOTIENDA,
  GETLISTEMPLEADOS,
  GETLISTEMPLEADOSCALENDARIO, GETLISTEMPLEADOSCALENDARIOXTIENDA, LIQUIDARCOMISIONEMPLE, UPDATETIENDAMAESTRA
} from '../queries/comision.query';
import {ComisionModel} from '../models/comision.model';
import {EmpleadoComisionesModel, EmpleadoComisionType} from '../models/empleado.comisiones.model';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {Observable} from 'rxjs';

@Injectable()
export class ComisionServices {

  public obsSendPptoTienda: Observable<any>;
  public obsSendPptoCol: Observable<any>;

  constructor(private apollo: Apollo, private ss: SocketServices) {
    this.obsSendPptoCol = this.ss.registrarEvento('sendPptoCol');
    this.obsSendPptoTienda = this.ss.registrarEvento('sendPptoTienda');
  }

  getPptoTienda(fechaIni: string, fechaFin: string) {
    this.ss.enviarEvento('getPptoTienda', {fIni: fechaIni, fFin: fechaFin});
  }

  getPptoCol(fechaIni: string, fechaFin: string){
    this.ss.enviarEvento('getPptoCol',{fIni: fechaIni, fFin: fechaFin});
  }

  getListEmpleados(semIni: any, semFinal: any, ano: any) {
    return this.apollo.query<any>({
      query: GETLISTEMPLEADOS,
      variables: {
        semIni: semIni - 1,
        semFinal: semFinal - 1,
        ano: ano
      }
    });

  }

  getListEmpleadosCalendarioXTienda(inicio: any, fin: any, tienda: string) {
    return this.apollo.query<any>({
      query: GETLISTEMPLEADOSCALENDARIOXTIENDA,
      variables: {
        inicio: inicio,
        fin: fin,
        tienda: tienda
      }
    });

  }

  getListEmpleadosCalendario(inicio: any, fin: any) {
    return this.apollo.query<any>({
      query: GETLISTEMPLEADOSCALENDARIO,
      variables: {
        inicio: inicio,
        fin: fin,
      }
    });

  }


  getInfoEmpleado(empleado: string, semIni: any, semFinal: any, ano: any) {
    return this.apollo.query<any>({
      query: GETINFOEMPLEADO,
      variables: {
        empleado: empleado,
        semIni: semIni - 1,
        semFinal: semFinal - 1,
        ano: ano
      }
    });
  }

  getInfoEmpleadoCalendario(empleado: string, inicio: any, fin: any) {
    return this.apollo.query<any>({
      query: GETINFOEMPLEADOCALENDARIO,
      variables: {
        empleado: empleado,
        semIni: inicio,
        semFinal: fin,
      }
    });
  }

  getInfoEmpleadoCalendarioTienda(empleado: string, tienda: string, inicio: any, fin: any) {
    return this.apollo.query<any>({
      query: GETINFOEMPLEADOCALENDARIOTIENDA,
      variables: {
        empleado: empleado,
        semIni: inicio,
        tienda: tienda,
        semFinal: fin,
      }
    });
  }

  newComision(comision: ComisionModel) {

    return this.apollo.mutate({
      mutation: ADDCOMISION,
      variables: {
        comision: JSON.stringify(comision)
      }
    });
  }

  getComision(id: any) {
    return this.apollo.query({
      query: GETCOMISION,
      variables: {
        id: id
      }
    });
  }

  getAllComisiones() {
    return this.apollo.query({
      query: GETALLCOMISIONES
    });
  }

  aprobarComision(idemple: string, usuarioApro: string, aprobado: boolean, observaciones: string[], fechas: string[]) {

    return this.apollo.mutate({
      mutation: APROBARCOMISIONEMPLE,
      variables: {
        idemple: idemple,
        usuario: usuarioApro,
        aprobado: aprobado,
        observaciones: observaciones,
        fechas: fechas
      }
    });
  }

  liquidarComision(idemple: string, valor: number, observaciones: string[], usuario: string[], fechas: string[]) {
    return this.apollo.mutate({
      mutation: LIQUIDARCOMISIONEMPLE,
      variables: {
        idemple: idemple,
        valor: valor,
        observaciones: observaciones,
        usuario: usuario,
        fechas: fechas
      }
    });
  }

  actualizarComision(idemple: string, valor: number, observaciones: string[], usuario: string[], fechas: string[]) {

    return this.apollo.mutate({
      mutation: ACTUALIZARCOMISIONEMPLE,
      variables: {
        idemple: idemple,
        valor: valor,
        observaciones: observaciones,
        usuario: usuario,
        fechas: fechas
      }
    });
  }

  actualizarComisionV2(idemple: string, valor: number, valorTienda: number, observaciones: string[], usuario: string[], fechas: string[]) {

    return this.apollo.mutate({
      mutation: ACTUALIZARCOMISIONEMPLEV2,
      variables: {
        idemple: idemple,
        valor: valor,
        valorTienda: valor,
        observaciones: observaciones,
        usuario: usuario,
        fechas: fechas
      }
    });
  }

  aprobarManualComision(idemple: string, observaciones: string[], usuario: string[], fechas: string[]) {


    return this.apollo.mutate({
      mutation: APROBARMANUALCOMISION,
      variables: {
        idemple: idemple,
        observaciones: observaciones,
        usuario: usuario,
        fechas: fechas
      }
    });
  }

  eliminarEmpleComision(id) {
    return this.apollo.mutate({
      mutation: ELIMINARCOMISIONEMPLE,
      variables: {
        id: id
      }
    });
  }

  addEmpleComision(id: string, ec: EmpleadoComisionesModel) {
    //
    // let ect: EmpleadoComisionType = new EmpleadoComisionType();
    // ect.cA = ec.cA;
    // ect.cAA = ec.cAA;
    // ect.cAAA = ec.cAAA;
    // ect.totCat = ec.totCat;
    // ect.cargo = ec.cargo;
    // ect.aprobado = ec.aprobado;
    // ect.estado = ec.estado;
    // ect.observaciones = ec.observaciones;
    // ect.usuarioAprueba = ec.usuarioAprueba;
    // ect.fechaObs = ec.fechaObs;
    // ect.fechaInicio = ec.fechaInicio;
    // ect.fechaFin = ec.fechaFin;

    return this.apollo.mutate({
      mutation: ADDUPDATEEMPLECOMISION,
      variables: {
        id: id,
        data: JSON.stringify(ec)
      }
    });
  }

  eliminarComision(id: string) {
    return this.apollo.mutate({
      mutation: ELIMINARCOMISION,
      variables: {
        id: id
      }
    });
  }

  getEmpleadoComision(comision: string, idUser: number) {

    return this.apollo.query({
      query: GETEMPLEADOSCOMISION,
      variables: {
        comision: comision,
        idUser: idUser
      }
    });
  }

  updateTiendaEmpleComision(idemple: string, tienda: string, observaciones: string[], usuario: string[], fechas: string[]) {


    return this.apollo.mutate({
      mutation: UPDATETIENDAMAESTRA,
      variables: {
        tiendaMaestra: tienda,
        idEmple: idemple,
        observaciones: observaciones,
        usuarioApro: usuario,
        fechas: fechas
      }
    });
  }


}
